import * as store from './index';
import {Role, DocRole, DocSourceType, QAIsOpen, QAInitStatus, InheritRepo} from '../Constant';
import {canEditInKnowledge} from '@/domains/space/Repository/knowledgeUtils';
import {IDocCardLikeInfo} from '@/interface';

export function curUserCanUpdateAll() {
    const curUserRole = store.getData(store.KEYS.CUR_DOCUMENT);
    // mde表示当前用户权限可添加删除其他人员
    return curUserRole && curUserRole.permissions?.includes('mde');
}

export function curUserOnlyUpdateReader() {
    const curUserRole = store.getData(store.KEYS.CUR_DOCUMENT);
    // mdr表示当前用户权限只可对可查看人员添加删除
    return curUserRole && curUserRole.permissions?.includes('mdr');
}

/*               知识库相关权限             */
// 判断当前用户是否可授予查看权限
export function curUserCanAuthorizeRead() {
    const curUserRole = store.getData(store.KEYS.CUR_DOCUMENT);
    return curUserRole.permissions?.some((val: any) => {
        return val === 'mdr';
    });
}

export function curUserRepositoryInviteReader() {
    const curUserRole = store.getData(store.KEYS.CUR_REPOSITORY);
    // mrr表示允许成员邀请只读成员
    return curUserRole && curUserRole.permissions?.includes('mrr');
}

export function curUserRepositoryInviteMember() {
    const curUserRole = store.getData(store.KEYS.CUR_REPOSITORY);
    // mrr表示允许成员邀请只读成员
    return curUserRole && curUserRole.permissions?.includes('mre');
}

export function getRepositoryType() {
    return store.getData(store.KEYS.CUR_REPOSITORY) && store.getData(store.KEYS.CUR_REPOSITORY).ownerType;
}

export function isAdminRepository() {
    const curUserRole = store.getData(store.KEYS.CUR_REPOSITORY)?.roleName;
    return curUserRole === Role.Admin || curUserRole === Role.Owner;
}

export function isMemberRepository() {
    const curUserRole = store.getData(store.KEYS.CUR_REPOSITORY)?.roleName;
    return curUserRole === Role.Member;
}

export function isAdminPage() {
    const curUserRole = store.getData(store.KEYS.CUR_DOCUMENT).repositoryRoleName;
    return curUserRole === Role.Admin || curUserRole === Role.Owner;
}

export function isMember() {
    // 是否为当前知识库成员（管理员 超管 成员皆为成员）
    const curUserRole = store.getData(store.KEYS.CUR_REPOSITORY)?.roleName;
    return [Role.Admin, Role.Owner, Role.Member].includes(curUserRole);
}

// 当前用户能否在当前文档邀请编辑者
export function curDocCanInviteEditor() {
    const docData = store.getData(store.KEYS.CUR_DOCUMENT);
    if (!docData || !docData.permissions) {
        return false;
    }
    return docData && (docData.permissions || []).includes('mde');
}

// 当前用户能否在当前文档邀请只读者
export function curDocCanInviteReader() {
    const docData = store.getData(store.KEYS.CUR_DOCUMENT);
    return docData && (docData.permissions || []).includes('mdr');
}

// 当前用户能否在当前文档邀请管理员
export function curDocCanInviteAdmin() {
    const docData = store.getData(store.KEYS.CUR_DOCUMENT);
    return docData && (docData.permissions || []).includes('mda');
}

// 是否为文档管理员
export function isCurDocPageAdmin() {
    const docData = store.getData(store.KEYS.CUR_DOCUMENT);
    return docData && docData.docRoleName === DocRole.DocAdmin;
}

// 是否为页面编辑者
export function isCurDocPageMember() {
    const docData = store.getData(store.KEYS.CUR_DOCUMENT);
    return docData && docData.docRoleName === DocRole.Member;
}

// 传参判断是否是页面管理员
export function isDocPageAdmin(docRoleName: string) {
    if (!docRoleName) {
        return false;
    }
    return docRoleName === DocRole.DocAdmin;
}

// 传参判断是否是页面成员
export function isDocPageMember(docRoleName: string) {
    if (!docRoleName) {
        return false;
    }
    return docRoleName === DocRole.Member;
}

export function isCurDocPageEditable() {
    const docData = store.getData(store.KEYS.CUR_DOCUMENT);
    const repoData = store.getData(store.KEYS.CUR_REPOSITORY);
    if (!docData || !repoData) {
        return false;
    }
    const canEditRepository = canEditInKnowledge(repoData, docData?.bookType, docData?.inheritRepo); // 知识库编辑权限
    const canEditDoc = docData.docRoleName === DocRole.Member; // 文档编辑权限
    const canEdit = canEditRepository || canEditDoc;
    return canEdit || isCurDocPageAdmin();
}

// 当前登录用户能否编辑对应文档权限的用户权限
export function cantEditorDocRoleName(docRoleName: string = '') {
    // 可以邀请管理员则可以拥有修改一切人的权限
    // 可以邀请编辑者则可以修改出来管理员以外的权限
    return curDocCanInviteAdmin()
            || (curDocCanInviteEditor() && docRoleName !== DocRole.DocAdmin)
            || (curDocCanInviteReader() && docRoleName === DocRole.Reader);
}

export const canEdit = (repository: Repository, doc: WizDocument) => {
    const canEditRespository = canEditInKnowledge(repository, doc?.bookType, doc?.inheritRepo); // 知识库编辑权限
    const canEditDoc = doc.docRoleName === DocRole.Member; // 文档编辑权限
    return canEditRespository || canEditDoc;
};

// 是否可编辑
export function docEditAble(repoData: Repository, docData: WizDocument) {
    return canEdit(repoData, docData) || isCurDocPageAdmin();
}

// 是否为导入文档
export function isImportDoc() {
    const sourceType = store.getData(store.KEYS.CUR_DOCUMENT)?.sourceType;
    return sourceType === DocSourceType.import;
}

// 智能问答已经开启
export function isQACenterOpened(isOpenQuestionAnswer?: any) {
    // 获取知识库问答中心开通状态
    const repoQAStatus = isOpenQuestionAnswer || store.getQuestionAnswerSwitch();
    return repoQAStatus?.chatRepo === QAIsOpen.isOpen && repoQAStatus?.chatRepoInitStatus === QAInitStatus.success;
}

// 智能问答在开启中
export function isQACenterOpening(isOpenQuestionAnswer?: any) {
    // 获取知识库问答中心开通状态
    const repoQAStatus = isOpenQuestionAnswer || store.getQuestionAnswerSwitch();
    return repoQAStatus?.chatRepo === QAIsOpen.isOpen && repoQAStatus?.chatRepoInitStatus === QAInitStatus.init;
}

// 智能问答未开通 且 未在开通中
export function isQACenterNotOpen(isOpenQuestionAnswer?: any) {
    // 获取知识库问答中心开通状态
    const repoQAStatus = isOpenQuestionAnswer || store.getQuestionAnswerSwitch();
    return repoQAStatus?.chatRepo !== QAIsOpen.isOpen || repoQAStatus?.chatRepoInitStatus === QAInitStatus.failed;
}

// 存储所有卡片点赞信息
export function setCardLikeInfo(docGuid: string, likeInfos: IDocCardLikeInfo[]) {
    store.setData(store.KEYS.CUR_DOC_CARD_LIKES_INFO, {
        docGuid,
        likeInfoList: likeInfos,
    });
}

// 添加单个卡片点赞信息
export function addCardLikeInfo(docGuid: string, likeInfo: IDocCardLikeInfo) {
    const {storeDocGuid = docGuid, likeInfoList} = store.getData(store.KEYS.CUR_DOC_CARD_LIKES_INFO);
    if (docGuid !== storeDocGuid) {
        console.error('error 文档id不一致');
        return;
    }
    const newList = likeInfoList.concat(likeInfo);
    store.setData(store.KEYS.CUR_DOC_CARD_LIKES_INFO, {
        docGuid,
        likeInfoList: newList,
    });
}

export function cancelCardLikeInfo(docGuid: string, blockId: string) {
    const {storeDocGuid = docGuid, likeInfoList} = store.getData(store.KEYS.CUR_DOC_CARD_LIKES_INFO);
    if (docGuid !== storeDocGuid) {
        console.error('error 文档id不一致');
        return;
    }
    const newList = likeInfoList.filter((data: IDocCardLikeInfo) => data.blockId !== blockId);
    store.setData(store.KEYS.CUR_DOC_CARD_LIKES_INFO, {
        docGuid,
        likeInfoList: newList,
    });
}

// 获取某个卡片点赞信息
export function getCardLikeInfo(docGuid: string, blockIds: string[]) {
    const {storeDocGuid = docGuid, likeInfoList} = store.getData(store.KEYS.CUR_DOC_CARD_LIKES_INFO);
    if (docGuid !== storeDocGuid) {
        console.error('error 文档id不一致');
        return;
    }
    return likeInfoList.filter((data) => {
        return blockIds.includes(data.blockId);
    });
}

// 更新某个卡片点赞信息 如果没有信息就新增
export function updateCardLikeInfo(docGuid: string, likeInfos: IDocCardLikeInfo[]) {
    const {storeDocGuid = docGuid, likeInfoList} = store.getData(store.KEYS.CUR_DOC_CARD_LIKES_INFO);
    if (docGuid !== storeDocGuid) {
        console.error('error 文档id不一致');
        return;
    }
    const likeInfosCache = likeInfos.concat([]);
    let newList = likeInfoList.map((data: IDocCardLikeInfo) => {
        let spliceIndex = 0;
        // blockId 相同时返回最新数据
        const updateInfo = likeInfosCache.find((item, index) => {
            if (item.blockId === data.blockId) {
                spliceIndex = index;
                return true;
            }
            return false;
        });
        if (updateInfo) {
            likeInfosCache.splice(spliceIndex, 1);
            return {
                data,
                ...updateInfo,
            };
        }
        return data;
    });
    newList = newList.concat(likeInfosCache);
    store.setData(store.KEYS.CUR_DOC_CARD_LIKES_INFO, {
        docGuid,
        likeInfoList: newList,
    });
}

